<script>
export default {
  title: "Redefina sua senha",
  mounted() {
    this.$refs.password.focus();
  },
  data() {
    return {
      donie: true,
      donieCovered: false,
      password: "",
      passwordConfirm: ""
    };
  },
  methods: {
    donieUncover() {
      this.donie = true;
      this.donieCovered = false;
    },

    donieCover() {
      this.donie = false;
      this.donieCovered = true;
    }
  }
};
</script>


<template>
  <div class="container-center">
    <div v-show="donie" class="donie">
      <img src="../../static/donie.svg" alt="Donie">
    </div>
    <div v-show="donieCovered" class="donie-covered">
      <img src="../../static/donie-blindfolded.svg" alt="Donie olhos fechados">
    </div>

    <div class="box text-center text-purple">
      <div class="logo">
        <img src="../../static/logo.svg" alt="Donamaid">
      </div>

      <b>Redefina sua senha</b>

      <input
        type="text"
        class="with-icon icon-password mt-20 mb-20"
        ref="password"
        placeholder="sua senha"
        @focus="donieCover()"
        @blur="donieUncover()"
        v-model="password"
        autocomplete="off"
      >

      <input
        type="text"
        class="with-icon icon-password mb-20"
        placeholder="confirme sua senha"
        @focus="donieCover()"
        @blur="donieUncover()"
        v-model="passwordConfirm"
        autocomplete="off"
      >

      <div class="text-center mt-20">
        <router-link to="/login">
          <button class="btn bg-pink mb-10">entrar</button>
        </router-link>
      </div>
    </div>
  </div>
</template>


<style scoped>
.container-center {
  position: absolute;
  background: #ededed;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box {
  width: 440px;
  margin-top: -25px;
  padding: 50px;
  margin-bottom: 20px;
  box-shadow: 10px 10px 15px -6px rgba(0, 0, 0, 0.23);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
}

.donie,
.donie-covered {
  width: 440px;
  height: 200px;
  display: inherit;
  margin-top: 20px;
  z-index: 99;
}

.donie img,
.donie-covered img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.logo {
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
  height: 60px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.icon-user {
  background: url("../../static/user.png") no-repeat 10px 10px;
  background-size: 20px;
}

.icon-password {
  background: url("../../static/lock.png") no-repeat 10px 10px;
  background-size: 20px;
}

@media (max-width: 768px) {
  .box {
    width: 340px;
  }
  .donie,
  .donie-covered {
    width: 440px;
  }
}

@media (max-width: 480px) {
  .box {
    width: 200px;
    margin-top: -25px;
  }
  .donie,
  .donie-covered {
    width: 300px;
  }
  .logo {
    margin-top: 0;
    margin-bottom: 20px;
  }
}

@media (max-width: 320px) {
  .box {
    width: 190px;
    margin-top: -43px;
    padding: 30px;
  }
  .donie,
  .donie-covered {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Forgot.vue